/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

function handleInitialAdjustments({
  questionnaire,
  lloydsLeaders,
}) {
  const lloydsLeaderQuestion = questionnaire.find(question => question.idQuestion === 1437);
  const idLloydsSelected = lloydsLeaderQuestion?.answer ? JSON.parse(lloydsLeaderQuestion?.answer)?.id : null;


  return questionnaire.map(question => {
    // Second Lloyds Leader
    if (question.idQuestion === 1443) {
      question.visibleQuestion = lloydsLeaders?.length > 1;
      question.behaviorObject.selectedLloyds = idLloydsSelected;
      question.disabled = idLloydsSelected ? false : true;
    }


    // Slip Leader
    if(question.idQuestion === 1451) { 
      question.behaviorObject.isRequired = true;
    }

    return question;
  })
};

async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaireUpdated,
  setFieldValue,
  globalQuestionnaire,
}) {
  try {
    let saveQuestionnaire = false;

    
    if(question.idQuestion === 1437) {
      let idLloydsSelected;

      if (!value) idLloydsSelected = null;
      idLloydsSelected = !value ? null : question?.answer ? JSON.parse(question?.answer)?.id : null;

      questionnaireUpdated = questionnaireUpdated.map(qst => {
        if (qst.idQuestion === 1443) {
          qst.behaviorObject.selectedLloyds = idLloydsSelected;
          qst.disabled = idLloydsSelected ? false : true;
          qst.answer = ""
          qst.answerJson = ""

          setFieldValue && setFieldValue(qst.key, "");
        }
  
        return qst;
      })
    }



    if(question.idQuestion === 1443) {
      let idLloydsSelected;

      idLloydsSelected = !value ? null : question?.answer ? JSON.parse(question?.answer)?.id : null;
      questionnaireUpdated = questionnaireUpdated.map(qst => {
        if (qst.idQuestion === 1437) {
          qst.behaviorObject.selectedLloyds = idLloydsSelected;
        }
  
        return qst;
      })
    }

    if (saveQuestionnaire) setQuestionnaireUpdated(questionnaireUpdated);

  } catch (e) {
    console.log('SECURITY_DETAILS - handleQuestionChange - error', e)
  }
};

function handleQuestionBlur({
  question,
  value,
  setFieldValue,
  formikRef,
  obligorGroup,
  setObligorGroup,
  index,
  values,
  setMaxValuePerc,
  mask,
  maskPercentage,
}) {
  try {
    
  } catch (e) {
    console.log("SECURITY_DETAILS - handleQuestionBlur error", e)
  }
}

async function handleRequestSerproCnpj({
  question: rootQuestion,
  data,
  questionnaire,
  setQuestionnaire,
  setFieldValue,
}) {
  try {
    questionnaire = questionnaire.map(question => {

      return question;
    })

    setQuestionnaire(questionnaire);
  } catch (e) {
    console.log('SECURITY_DETAILS - handleRequestSerproCnpj - error', e)
  }
};

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
  handleQuestionBlur,
  handleRequestSerproCnpj,
};

export { events };